export default __webpack_public_path__ + "static/media/challenge-list-icon.93ade839.svg";